import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { BusinessLoader } from "./BusinessLoader";
import { cssTextDark } from "./Library";

export function InternalReviewLink() {
    const { loading, hasInternalReviews } = BusinessLoader();

    if (loading) return <p><em>Loading�</em></p>;
    if (!hasInternalReviews) return null;

    return <NavItem><NavLink to="/reviews" tag={Link} class={cssTextDark }>Internal Reviews</NavLink></NavItem>;
}
